<template>
  <div class="form-container">
    <div class="dashboard">
      <h1>ダッシュボード</h1>
      <div class="header">
        <div class="login-info">前回ログイン日時: {{ formattedLoginTime }}</div>
      </div>
      <h2>システム更新情報</h2>
      <div class="update-list">
        <div class="update-item">
          <div class="update-date">2025年1月1日</div>
          <div class="update-description">システムをリリースしました。</div>
        </div>
      </div>
    </div>
  </div>
  
</template>
<script>
export default {
  data() {
    return {
      loginTime: new Date() // 現在時刻をログイン時刻として使用
    };
  },
  computed: {
    formattedLoginTime() {
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false // 24時間形式にする
      };

      // 日本語形式で年月日と時間をフォーマット
      return this.loginTime.toLocaleString('ja-JP', options).replace(
        /(\d+)\/(\d+)\/(\d+), (\d+):(\d+)/,
        '$3年$2月$1日 $4:$5'
      );
    }
  }
};
</script>

<style scoped>
.dashboard {
  background-color: #d4f1c5;
  border-radius: 8px;
}

.header {
  background-color: #eaeaea;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.login-info {
  font-size: 0.9em;
  color: #333;
  font-size: inherit; /* 親要素のフォントサイズを継承 */
}

.update-list {
  margin-top: 20px;
}

.update-item {
  display: flex;
  flex-direction: column;
  padding: 15px;
  border-bottom: 1px solid #ddd;
  transition: background-color 0.2s ease;
}

.update-item:not(:last-child) {
  margin-bottom: 10px;
}

.update-date {
  font-weight: bold;
  color: #555;
  font-size: inherit; /* 親要素のフォントサイズを継承 */
}

.update-description {
  margin-top: 5px;
  color: #333;
  line-height: 1.6;
  font-size: inherit; /* 親要素のフォントサイズを継承 */
}

.update-item:hover {
  background-color: #f5f5f5;
  border-radius: 5px;
}
</style>